import { RichText } from '@/components/RichText';
import { FieldBuilderComponentPropsType } from '../types';
export function RichTextField({
  data
}: FieldBuilderComponentPropsType<'ConversionFormStepsFieldsRichText'>) {
  return <RichText>{data.richText}</RichText>;
}